<script lang="ts">
	import { createEventDispatcher } from 'svelte'
	import type { HTMLInputTypeAttribute } from 'svelte/elements'

	import { BORDER_GROUP_TYPE, CLASS_SIZE } from '../ComponentProperties'

	const dispatch = createEventDispatcher()

	export let value: string | null = ''
	export let type: HTMLInputTypeAttribute = 'text'
	
	export let className = ''
	export let noInputStyles = false
	export let useBox = true
	
	export let required = false
	export let text_right = false
	export let classGroup: BORDER_GROUP_TYPE = BORDER_GROUP_TYPE.ALONE
	export let classSize: CLASS_SIZE = CLASS_SIZE.MD
	export let disabled = false

	export let mask = ''
	export let placeholder = mask

	export const focus = () => {handleFocus()}

	function handleFocus() {
		myInput.focus()
	}

	let myInput: HTMLInputElement

	$: class_input_default = useBox ? 'default-input' : 'default-input-data'

	function handleInput(event: Event) {
		if (!(event.currentTarget instanceof HTMLInputElement)) {
			return
		}
		value = event.currentTarget.value

		dispatch('change', value)
	}
</script>

<input
	data-hj-allow
	bind:this={myInput}
	class="{noInputStyles ? '' : class_input_default} {className} {classSize} {classGroup}"
	class:text_right
	{type}
	{placeholder}
	{required}
	{value}
	{disabled}
	{...$$restProps}
	on:input={handleInput}
	on:focus
	on:blur
	on:keypress
/>

<style lang="postcss">
	.text_right {
		@apply text-right;
	}

	/* ------ */
	/* size   */
	.size_sm {
		font-size: 16px;
		padding: 8px 6px;
	}

</style>
